import { CMSContentClient } from '@seuk/cms-api-client';
import { isCMSPreview } from '@seuk/util';

let client: CMSContentClient;
export const getCMSClient = (isPreview = false) => {
  if (isPreview) {
    return new CMSContentClient({
      accessToken: process.env.CONTENTFUL_CONTENT_DELIVERY_PREVIEW_TOKEN,
      space: process.env.CONTENTFUL_SPACE,
      environment: process.env.CONTENTFUL_ENV,
      isPreview: true,
      insecure: false,
    });
  }

  if (!client) {
    client = new CMSContentClient({
      accessToken: process.env.CONTENTFUL_CONTENT_DELIVERY_TOKEN,
      space: process.env.CONTENTFUL_SPACE,
      environment: process.env.CONTENTFUL_ENV,
      isPreview: isCMSPreview(),
      insecure: false,
    });
  }

  return client;
};
